import AggiungiAllegato from "./AggiungiAllegato";
import ChangeStatus from "./ChangeStatus";

const Dialogs = {
    AggiungiAllegato,
    ChangeStatus,
}
export default Dialogs;